"use client";

import { useEffect } from "react";
import { useAuthContext } from "@/context/authContext";
import { useCollectionsStore } from "@/stores/collectionsStore";

export default function UserSync() {
  const { userId, isLoaded } = useAuthContext();

  useEffect(() => {
    if (isLoaded) {
      useCollectionsStore.getState().actions.setUserId(userId);
    }
  }, [userId, isLoaded]);

  return null;
}
